export const FEATURE_FLAG_DEV_PANEL = {
  featureDevPanel: {
    title: 'Feature Flags (Dev Only)',
    description: 'Override local and external feature flags here',
    button: 'Feature Flags',
    reset: 'Reset Flags',
  },
}
